var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MoLayout',[(_vm.isError)?[_c('h2',[_vm._v("邮箱验证失败，链接已失效")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }